import type { AnalyticsMarket } from './contracts';

export interface AnalyticsConfig {
  enabled: boolean;
  market: AnalyticsMarket | null;
  measurementId: string | null;
}

interface AnalyticsEnvironment {
  VITE_ANALYTICS_ENABLED?: string;
  VITE_ANALYTICS_MARKET?: string;
  VITE_YANDEX_METRIKA_ID?: string;
  VITE_GOOGLE_ANALYTICS_ID?: string;
}

export function readAnalyticsConfig(
  environment: AnalyticsEnvironment = import.meta.env
): AnalyticsConfig {
  const market = environment.VITE_ANALYTICS_MARKET;
  const normalizedMarket = market === 'ru' || market === 'global' ? market : null;
  const measurementId =
    normalizedMarket === 'ru'
      ? environment.VITE_YANDEX_METRIKA_ID
      : normalizedMarket === 'global'
        ? environment.VITE_GOOGLE_ANALYTICS_ID
        : undefined;
  return {
    enabled: environment.VITE_ANALYTICS_ENABLED === 'true',
    market: normalizedMarket,
    measurementId:
      typeof measurementId === 'string' && measurementId.trim() ? measurementId.trim() : null,
  };
}
